export const product = {
  name: 'Crédito Limpio en 30 Días',
  id: '51220922433703',
  price: 6.39,
  compareAtPrice: 19.0,
  currency: 'USD',
  /** Pega aquí la URL del checkout cuando esté lista. */
  checkoutUrl: '',
}
